export default __webpack_public_path__ + "ui/assets/img/arrow-list-down-20-link.svg";